import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface CondicaoRegraPagamento {
  id?: string;
  // Adicione os campos necessários conforme o modelo real
}

@Injectable({
  providedIn: 'root'
})
export class CondicaoRegraPagamentoService {
  private readonly path = 'bolsa';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: CondicaoRegraPagamento[] }>(`${this.path}`, params ? new HttpParams({ fromObject: params }) : this.params).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get<{ object: CondicaoRegraPagamento }>(`${this.path}/${id}`).pipe(
      map(response => response)
    );
  }

  store(condicao: CondicaoRegraPagamento): Observable<any> {
    return this.apiService
      .post<{ object: CondicaoRegraPagamento }>(`${this.path}`, condicao)
      .pipe(map(response => response));
  }

  update(condicao: CondicaoRegraPagamento): Observable<any> {
    return this.apiService
      .put<{ object: CondicaoRegraPagamento }>(`${this.path}`, condicao)
      .pipe(map(response => response));
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/${id}`);
  }
}
